module.exports = __webpack_public_path__ + "img/natale2022.62be14c6.png";